import { IAuthenticationResult } from "../interfaces/IAuthenticationResult";
import api from "./Api";

class AuthService {
    async signIn(email: string, senha: string): Promise<IAuthenticationResult> {
        let { data: result } = await api.post<IAuthenticationResult>('Autenticacao', { email, senha });

        return result;
    }

    async resetPassword(email: string): Promise<void> {
        await api.post('esqueci-minha-senha', { email });
    }
}


export default new AuthService();